function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:none;stroke:#000;stroke-miterlimit:10;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m0,1.41v16.06h18.99V1.41H0Zm12.98,1c-.1,1.04-.38,6.41,3.43,14.06H2.7c3.81-7.65,3.53-13.03,3.43-14.06h6.84ZM1,2.41h4.13c.05.47.57,6.06-3.54,14.06h-.59V2.41Zm16.99,14.06h-.47c-4.1-7.97-3.6-13.58-3.54-14.06h4.01v14.06Z"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  className: "b",
  y1: 18.48,
  x2: 18.99,
  y2: 18.48
});

function SvgFenster(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.99 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFenster);
export default __webpack_public_path__ + "static/media/fenster.3161dfa0f3bef6b504518ed138e9165d.svg";
export { ForwardRef as ReactComponent };